import './RiseEventReport.css'
import React, { useEffect, useState, useRef } from 'react'
import "react-datepicker/dist/react-datepicker.css";
import { Api } from "../../../../helpers/Api";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from '../Spinner/LoadingSpinner';
import { connect } from "react-redux";
import { jsPDF } from "jspdf";
import Blob from "blob";
import dateFormat from '../../../../helpers/DateFormate';
import Moment from 'moment';
import html2canvas from 'html2canvas';

const RiseEventReport = () => {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [images, setImages] = useState([]);
    const [count, setCount] = useState(0);
    const parms = useParams();
    const [loading, setLoad] = useState(false);

    const load = (id) => {
        Api.call(`/getReport/${id}`).then(post => {
            setData(post)
            dataSet(post);
            setTimeout(() => {
                console.log(data);
            }, 2000)
        }).catch(console.log).finally(() => {
            console.log(data);
        });
    }

    const dataSet = async(data)=>{
    const srcs = [];
    let imagecount = 0; 
    data?.EventsPhotos?.forEach(element => {
        fetch(element?.imageUrl.replace("itmatic.io", "codebrigade.in")).then((response) => {
          if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.blob();
      })
      .then((blob) => {
        const reader = new FileReader();

        // Use a promise to handle FileReader
        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                resolve(reader.result); // Base64 string
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob); // Read the Blob as Base64
        });
    })
    .then((base64String) => {
        var key = element?.imageUrl
      srcs[key]={"url":base64String,"caption":element?.caption};
      imagecount++;
      if (imagecount ==  data?.EventsPhotos?.length) {
        setImages(srcs);
        setCount(imagecount);
    }
    })
      .catch((error) => {
          console.error('Error fetching the image:', error);
      })
   });
  }

    const nl2br = (str = '', is_xhtml) => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        str = (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        return str;
    }
    useEffect(() => {
        if (data && count > 0) {
            // document.getElementById("outcomes").innerHTML = nl2br(data.outcomes); 
            document.getElementById("Objective").innerHTML = nl2br(data.objective);
        }
    }, [data?.outcomes, data?.Description,count])

    useEffect(() => {
        load(parms.id)
    }, [parms.id])

    const wordFormat = async() => {

        var doc = new jsPDF();

        const imgWidth = 210;
        const firstDivCanvas = await html2canvas(document.getElementById('pdfImages'),{scale: 1, 
        width: window.innerWidth/1.34,
        height: document.getElementById('pdfImages').offsetHeight});
        const firstDivImgData = firstDivCanvas.toDataURL('image/png');
        const firstDivHeight = (firstDivCanvas.height * (imgWidth)) / (firstDivCanvas.width);
        const firstDiv = document.getElementById('page');   
        await doc.html(firstDiv, {
            callback: function (doc) {
            },
            margin: [5, 0, 27, 7],
            autoPaging: 'text',
            width: 180, //target width in the PDF document
            windowWidth: 850 //window width in CSS pixels
        });
        doc.addPage();
        doc.addImage(firstDivImgData, 'PNG', -25, 0, imgWidth, firstDivHeight);
        getHeader(doc);
        doc.save(`${data?.template?.name}.pdf`);
        return;
    }

    const getHeader = (doc) => {
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(0);

            doc.text(doc.internal.pageSize.getWidth() - 19, doc.internal.pageSize.getHeight() - 1, `Page ${i} of ${totalPages}`);
            doc.setFontSize(8);
            doc.setTextColor(0);
            doc.text(0, doc.internal.pageSize.getHeight() - 1, `${data?.template?.name}(${data?.template?.start_date} to ${data?.template?.end_date})`);
        }  
    }

    if(count==0){ return <LoadingSpinner />; }
    return ( 
        <div className='container p-3' >
            <div className='Form-buttons mt-1'>
                <button onClick={() => { setLoad(true); wordFormat(); setLoad(false); }} className='cancel mb-5'>{loading == true ? "Loading" : "Download"}</button>
            </div>
            <div style={{ padding: '5px' }} id="page">
                <table align="center" style={{ width: "920px" }} cellspacing='0' cellpadding='10' class="rise-event-pdf">
                    <tr class="header-section">
                        <tr>
                            <td style={{ width: "50%" }} ><img src='../../../../images/logo2.png' alt="Logo" /></td>
                            <td className="event-heading">Guidelines for RISE Events 1.0</td>
                        </tr>
                    </tr>
                    <tr>
                        <td><hr className='divider' /></td>
                    </tr>

                    <table align="center" class="rise-report" style={{ width: "920px" }} >
                        <tr>
                            <th>{data?.template?.name} Report</th>
                        </tr>
                    </table>
                    <table align="center" class="report-content" style={{ width: "920px" }} >
                        <tr>
                            <td>
                                1.
                                <b> RISE Event ID : </b>
                                <input className="input-field" style={{ borderTop: "none", borderLeft: "none", borderRight: "none" }} value={data?.id} type="text" name="fname" />
                            </td>
                        </tr>
                        <tr><td height="20px"></td></tr>
                        <tr>
                            <td>
                                2.
                                <b> Name of the Event (write full name): </b>
                                <br></br>
                                <input style={{ width: "100%", marginLeft: '20px', borderTop: "none", borderLeft: "none", borderRight: "none" }} value={data?.template?.name} className="input-field" type="text" name="fname" />
                            </td>
                        </tr>
                        <tr><td height="20px"></td></tr>
                        <tr>
                            <td>
                               <p> 3.
                                <b> Event dates: </b> from
                                <input style={{ width: "15%", borderTop: "none", borderLeft: "none", borderRight: "none" }} value={Moment(data?.template?.start_date).format(dateFormat.ReportDateFormat)} className="input-field" type="text" name="fname" />
                                to
                                <input style={{ width: "15%", borderTop: "none", borderLeft: "none", borderRight: "none" }} value={Moment(data?.template?.end_date).format(dateFormat.ReportDateFormat)} className="input-field" type="text" name="fname" /></p>
                            </td>
                        </tr>
                        <tr><td height="20px"></td></tr>
                        <tr>
                            <td>
                                4.
                                <b> Name of the convenor: </b>
                                <br></br>
                                <input style={{ width: "90%", marginLeft: '20px', borderTop: "none", borderLeft: "none", borderRight: "none" }} value={data?.template?.organized_by} className="input-field" type="text" name="fname" />
                            </td>
                        </tr>
                        <tr><td height="20px"></td></tr>
                        <tr>
                            <td>
                                5.
                                <b> Name of the school/college/research lab/ centre holding the event:</b>
                                <br></br>
                                <input style={{ width: "90%", marginLeft: '20px', borderTop: "none", borderLeft: "none", borderRight: "none" }} value={data?.template?.department?.name} className="input-field" type="text" name="fname" />
                                <br></br>
                            </td>
                        </tr>
                        <tr><td height="20px"></td></tr>
                        <tr>
                            <td>
                                6.
                                <b> Objectives behind conduction of the event (Enlist atleast 3 detailed objectives in bullet points) :</b>
                                <div id="Objective">{data?.objective}</div>
                            </td>
                        </tr>
                        <tr><td height="20px"></td></tr>
                        <tr>
                            <td>
                                7.
                                <b> Total no. of attendees in the event: </b>
                            </td>
                        </tr>
                        <tr><td height="20px"></td></tr>

                        <table className="attendees-event" style={{ width: "920px" }}>
                            <tr>
                                <th colSpan="2" style={{ width: "50%", border: "1px solid black" }}>Internal</th>
                                <th colspan="2" style={{ width: "50%", border: "1px solid black" }}>External</th>
                            </tr>
                            <tr>
                                <td style={{ textAlign: "center", border: "1px solid black", borderCollapse: "collapse" }}>Faculty/ Scholars</td>
                                <td style={{ textAlign: "center", border: "1px solid black", borderCollapse: "collapse" }}>Students</td>
                                <td style={{ textAlign: "center", border: "1px solid black", borderCollapse: "collapse" }}>Faculty/ Scholars/ Members from Industry or Professional Body</td>
                                <td style={{ textAlign: "center", border: "1px solid black", borderCollapse: "collapse" }}>Students</td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: "center", border: "1px solid black", borderCollapse: "collapse" }}>{data?.faculty ? data?.faculty : 0}</td>
                                <td style={{ textAlign: "center", border: "1px solid black", borderCollapse: "collapse" }}>{data?.participants ? data?.participants : 0}</td>
                                <td style={{ border: "1px solid black", borderCollapse: "collapse" }}>{data?.facultyExternal ? data?.facultyExternal : 0}</td>
                                <td style={{ border: "1px solid black", borderCollapse: "collapse" }}>{data?.participantsExternal ? data?.participantsExternal : 0}</td>
                            </tr>
                            {/* <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr> */}
                        </table>
                        <tr><td height="20px"></td></tr>
                        <tr>
                            <td>
                                8.
                                <b> Names of the external resource persons with their full affiliations</b>
                            </td>
                        </tr>
                        <tr><td height="20px"></td></tr>
                        <table className="attendees-event" style={{ width: "920px" }}>
                            <tr>
                                <th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Sr. no.</th>
                                <th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Name of the resource person</th>
                                <th style={{ border: "1px solid black", borderCollapse: "collapse" }}>Full affiliation</th>
                            </tr>
                            {data?.template?.resource_persons?.map((d, index) => {
                                return <tr>
                                    <td style={{ textAlign: "center", border: "1px solid black", borderCollapse: "collapse" }}>{index + 1}</td>
                                    <td style={{ textAlign: "center", border: "1px solid black", borderCollapse: "collapse" }}>{d.name}</td>
                                    <td style={{ textAlign: "center", border: "1px solid black", borderCollapse: "collapse" }}>{d.designation}</td>
                                </tr>
                            })}
                        </table>

                        <tr><td height="20px"></td></tr>
                        <br></br>
                        <tr>
                            <td>
                                9.
                                <b> Testimonials from atleast five participants to be typed herewith along with their names and contact details </b>
                            </td>
                        </tr>
                        <tr><td height="20px"></td></tr>
                        <table className="attendees-event" style={{ width: "100%" }}>
                            {data?.students?.map((d) => {
                                return <tr>
                                    <td style={{ width: "50%" }}>{d?.name}</td>
                                    <td>{d?.email}</td>
                                </tr>
                            })}
                        </table>

                        <tr><td height="20px"></td></tr>
                        <tr>
                            <td>
                                10.
                                <b> Write up of the event in about 200 to 300 words </b>
                                <br></br>
                            </td>
                        </tr>
                        <tr><td height="20px">{data?.Description}</td></tr>
                    </table>
                </table>
                </div>
            <div id="pdfImages" style={{ pageBreakBefore: "always" }}>
            <table width="100%" align="center" class="report-content">
                <tr>
                    <td>
                        11.
                        <b> Paste three photographs (1 each for inaugural, conduct of event and valedictory)  </b>
                    </td>
                </tr>
                <table width="100%" align="center" class="report-table">
                    <tr>
                        <td style={{ width: "50%", border: "1px solid black", borderCollapse: "collapse", padding: "10px" }} align='center'>
                            <img src={count>0 ? images[data?.EventsPhotos[0]?.imageUrl].url : ''} width="300" height="200" />
                        </td>
                        <td style={{ width: "50%", border: "1px solid black", borderCollapse: "collapse", padding: "10px" }} align='center'>
                            <img src={count>0 ? images[data?.EventsPhotos[1]?.imageUrl].url : ''} width="300" height="200" />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "50%", border: "1px solid black", borderCollapse: "collapse", padding: "10px" }} align='center'>
                            <img src={count>0 ? images[data?.EventsPhotos[2]?.imageUrl].url : ''} width="300" height="200" />
                        </td>
                        <td style={{ width: "50%", border: "1px solid black", borderCollapse: "collapse", padding: "10px" }} align='center'>
                            <img src={count>0 ? images[data?.EventsPhotos[3]?.imageUrl].url : ''} width="300" height="200" />
                        </td>
                    </tr>
                </table>
            </table>
            </div>
        </div>
    );

};

export default RiseEventReport;